export default function AppSection() {
  return (
    <section
      id="app"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          {/* Left: Text */}
          <div className="w-full lg:w-1/2 flex flex-col gap-3">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              移动吃瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              随时随地掌握娱乐热点。今日大瓜移动端网页版已全面优化，
              在任何设备上都能享受流畅的吃瓜体验。原生App即将上线，敬请期待。
            </p>
            <ul className="flex flex-col gap-2 mt-1">
              {['即时推送热点爆料通知', '离线缓存精彩吃瓜内容', '个性化定制关注明星动态', '一键分享大瓜到社交平台'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-foreground-700">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-check-line text-primary-600 text-xs"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <div className="flex gap-3 mt-2">
              <span className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-md">
                <i className="ri-apple-fill"></i>
                App Store
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-md">
                <i className="ri-google-play-fill"></i>
                Google Play
              </span>
            </div>
          </div>

          {/* Right: Image */}
          <div className="w-full lg:w-1/2 flex items-center justify-center">
            <div className="relative w-48 md:w-56 aspect-[9/16] rounded-xl overflow-hidden border-4 border-foreground-900">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20showing%20entertainment%20news%20app%20interface%20with%20clean%20modern%20design%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20trending%20topics%20list%20with%20thumbnail%20images%2C%20minimalist%20UI%2C%20Chinese%20language%20content%20layout%2C%20soft%20gradient%20background&width=500&height=900&seq=app-mockup-01&orientation=portrait"
                alt="今日大瓜移动端界面预览"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}